import React, { useState, useEffect } from 'react';
import '../styles/MobileNavigation.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Home01Icon, Plug02Icon, Settings01Icon, UserCircleIcon } from '@hugeicons/core-free-icons';
import { colour } from '../styles/GlobalStyles';
import MobileTab from './MobileTab';

function MobileNavigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleWindowResize = () => {
            setInnerWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    // Only show on mobile (same breakpoint as Settings.js uses)
    if (innerWidth >= 999) {
        return null;
    }

    const navigationItems = [
        {
            path: '/',
            title: 'Home',
            icon: Home01Icon
        },
        {
            path: '/integrations',
            title: 'Integrations',
            icon: Plug02Icon
        },
        {
            path: '/settings',
            title: 'Settings',
            icon: Settings01Icon
        },
        {
            path: '/profile',
            title: 'Profile',
            icon: UserCircleIcon
        }
    ];

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <div className="mobile-navigation-container">
            {navigationItems.map((item, index) => (
                <MobileTab
                    key={index}
                    item={item.path}
                    title={item.title}
                    active={location.pathname === item.path}
                    icon={
                        <HugeiconsIcon 
                            icon={item.icon} 
                            size={16} 
                            color={location.pathname === item.path ? colour.gray06 : colour.gray05} 
                        />
                    }
                    cta={(path) => handleNavigation(path)}
                    disabled={false}
                    line={true}
                />
            ))}
        </div>
    );
}

export default MobileNavigation;

